export default __webpack_public_path__ + "static/media/south-by-sea-white.e805f201.png";